import { EEntities } from '@/types'
import Permissions from '@/plugins/permissions/permissions'
import VueRouter from 'vue-router'
import MailboxesAPI from '@/api/modules/mailboxes.api'
import InternalProjectsAPI from '@/api/modules/internal-projects.api'
import AccountMembershipsAPI from '@/api/modules/account-memberships.api'

export default new class AppSumoAssistant {
  /* Used for third-party access to the "New Mailbox" or "New Project" buttons */
  public getNewEntityButtonMarkerClass(entityType: string): string {
    switch (entityType) {
      case EEntities.MAILBOXES:
        return 'marker--dashboard--button--new-mailbox'
      case EEntities.PROJECTS:
        return 'marker--dashboard--button--new-project'
    }
  }

  public getCreateAccountMembershipButtonMarkerClass(): string {
    return 'marker--button--create-account-membership'
  }

  /* Also sends event to Appcues about the limit */
  public async isUnderMailboxLimit(
    router: VueRouter,
    permissions: Permissions,
  ): Promise<boolean> {
    if (permissions.isAppSumoAccount) {
      const appcues_OwnerPermaLink = '9847441c-efd3-4dfe-b61d-ff98b35e20f5'
      const appcues_AdminPermaLink = 'f2531231-7a78-4c9b-88ae-46acf77b343b'

      const appcues_PermaLink = permissions.isOwner
        ? appcues_OwnerPermaLink
        : appcues_AdminPermaLink

      const limitCheck = await MailboxesAPI.get_LimitCheck()
      if (limitCheck.reachedLimit) {
        console.log('AppSumo mailbox limit reached.')
        router.push({
          query: {
            appcue: appcues_PermaLink,
            rand: Math.random().toString(),
          },
        })
      }
      return !limitCheck.reachedLimit
    }
    return true
  }

  /* Also sends event to Appcues about the limit */
  public async isUnderInternalProjectLimit(
    router: VueRouter,
    permissions: Permissions,
  ): Promise<boolean> {
    if (permissions.isAppSumoAccount) {
      const appcues_OwnerPermaLink = '1c1e7ce6-10fc-46d8-8852-0f074d56f4e6'
      const appcues_AdminPermaLink = 'cf0e3a0a-d72f-42c9-8ceb-a061a9941bc2'

      const appcues_PermaLink = permissions.isOwner
        ? appcues_OwnerPermaLink
        : appcues_AdminPermaLink

      const limitCheck = await InternalProjectsAPI.get_LimitCheck()
      if (limitCheck.reachedLimit) {
        console.log('AppSumo project limit reached.')
        router.push({
          query: {
            appcue: appcues_PermaLink,
            rand: Math.random().toString(),
          },
        })
      }
      return !limitCheck.reachedLimit
    }
    return true
  }

  /* Also sends event to Appcues about the limit */
  public async isUnderAccountMembershipsLimit(
    router: VueRouter,
    permissions: Permissions,
  ): Promise<boolean> {
    if (permissions.isAppSumoAccount) {
      const appcues_OwnerPermaLink = '71e61fe2-c080-4371-9ddb-89c62f39c9f0'
      const appcues_AdminPermaLink = 'f23b83da-f718-41e6-85f6-68f56db404d9'

      const appcues_PermaLink = permissions.isOwner
        ? appcues_OwnerPermaLink
        : appcues_AdminPermaLink

      const limitCheck = await AccountMembershipsAPI.get_LimitCheck()
      if (limitCheck.reachedLimit) {
        console.log('AppSumo account membership limit reached.')
        router.push({
          query: {
            appcue: appcues_PermaLink,
            rand: Math.random().toString(),
          },
        })
      }
      return !limitCheck.reachedLimit
    }
    return true
  }
}()
